class ClickTracker {
  constructor() {
    this.storageKey = 'click_tracking_data';
    this.init();
  }

  init() {
    this.captureClickIds();
  }

  captureClickIds() {

    const trackingParams = {
        'gclid': 'gclid',
        'gclsrc': 'gclsrc',
        'wbraid': 'wbraid',
        'gbraid': 'gbraid',
        'dclid': 'dclid',
        'fbclid': 'fbclid',
        'fbc': 'fbc',
        'utm_source': 'utm_source',
        'utm_medium': 'utm_medium',
        'utm_campaign': 'utm_campaign',
        'utm_id': 'utm_id',
        'utm_term': 'utm_term',
        'utm_content': 'utm_content'
    };

    // Handle URL params
    const urlParams = new URLSearchParams(window.location.search);
    const clickData = this.getData();

    Object.entries(trackingParams).forEach(([param, key]) => {
      const value = urlParams.get(param);
      if (value) {
        clickData[key] = value;
      }
    });
      // Handle GA session
      const parseGoogleStreamCookie = () => {

        const ga4Cookie = this.getCookie('_ga_62LQMP5B65')

        if (!ga4Cookie) {
          return null
        }

        const mapping = {
          s: "sessionId",
          o: "sessionNumber",
          g: "sessionEngaged",
          t: "lastHitTimestamp",
          j: "joinTimer",
          l: "enhancedUserIdLoggedInState",
          h: "enhancedUserId",
          d: "joinId"
        };
        
        const [version, , data] = ga4Cookie.split('.');
        
        if (version === 'GS1') {
          const values = ga4Cookie.split('.').slice(2);
          const keys = ['s', 'o', 'g', 't', 'j', 'l', 'h', 'd'];
          return Object.fromEntries(
            keys.map((k, i) => [mapping[k], values[i] || ''])
          );
        }
        
        return Object.fromEntries(
          data.replace(/%24/g, '$').split('$')
              .map(s => [mapping[s[0]] || s[0], decodeURIComponent(s.slice(1))])
        );
      };

      const gSession = parseGoogleStreamCookie();

      if (gSession) {
        clickData['ga_client_id'] = gSession.enhancedUserId + '.' +  gSession.lastHitTimestamp
        clickData['ga_session_id'] = gSession.sessionId
        clickData['ga_session_number'] = gSession.sessionNumber
      }

    // Store object
    if (Object.keys(clickData).length > 0) {
      clickData.captured_at = new Date().toISOString();
      localStorage.setItem(this.storageKey, JSON.stringify(clickData));
    }
  }

  getData() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : {};
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
}

window.clickTracker = new ClickTracker();